// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__36l4F","formSpace":"styles_formSpace__2pRcW"};